module.exports = __webpack_public_path__ + "img/zh_cn.b41f208e.png";